import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaEye } from 'react-icons/fa6';
import axios from 'axios';
import { ApiUrl } from 'Services/Services'; // adjust path as needed

function ViewUser() {
  const { id } = useParams();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await axios.get(`${ApiUrl}/auth/users/${id}`);
        setUser(res.data);
      } catch (err) {
        console.error('Failed to fetch user:', err);
      }
    };

    fetchUser();
  }, [id]);

  if (!user) return <div className="text-center mt-10">Loading user data...</div>;

  return (
    <div className="max-w-4xl mx-auto p-6 mt-10 bg-white rounded-xl shadow-md">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold">User Details</h2>
        <FaEye className="text-blue-600 text-xl" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <p className="text-gray-500">Name</p>
          <p className="font-semibold">{user.name}</p>
        </div>
        <div>
          <p className="text-gray-500">Email</p>
          <p className="font-semibold">{user.email}</p>
        </div>
        <div>
          <p className="text-gray-500">Phone Number</p>
          <p className="font-semibold">{user.phoneNumber || 'N/A'}</p>
        </div>
        <div>
          <p className="text-gray-500">Role</p>
          <p className="font-semibold capitalize">{user.role}</p>
        </div>
        <div>
          <p className="text-gray-500">Verified</p>
          <p className={`font-semibold ${user.isVerified ? 'text-green-600' : 'text-red-500'}`}>
            {user.isVerified ? 'Yes' : 'No'}
          </p>
        </div>
        <div>
          <p className="text-gray-500">Created At</p>
          <p className="font-semibold">{new Date(user.createdAt).toLocaleString()}</p>
        </div>
      </div>

      {user.locations?.length > 0 && (
        <div className="mt-8">
          <h3 className="text-lg font-bold mb-4">Saved Locations</h3>
          <div className="space-y-4">
            {user.locations.map((loc) => (
              <div key={loc.id} className="border p-4 rounded-md bg-gray-50">
                <p><span className="text-gray-500">Label:</span> {loc.label}</p>
                <p><span className="text-gray-500">Address:</span> {loc.address}</p>
                <p><span className="text-gray-500">Lat/Lng:</span> {loc.latitude}, {loc.longitude}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewUser;
